// @flow

import _ from 'lodash/fp';
import React from 'react';
import Paginator from '../Paginator/Paginator';
import CustomerProductCard, {getVariantOptions} from '../CustomerProductCard/CustomerProductCard';
import './CustomerProductList.css';

const amountOfPages = (variants, {perPage}) => {
  return Math.ceil(variants.length / perPage);
};

const paginate = (variants, {page, perPage}) => {
  const pages = amountOfPages(variants, {perPage});
  const currentPage = page <= pages ? page : 1;
  const beginSlice = (currentPage - 1) * perPage;
  const endSlice = beginSlice + perPage;

  return variants.slice(beginSlice, endSlice);
};

export type Props = {
  products: any[],
  pagination: Object,
  isLoading: boolean,
  onOpenProduct: Function,
  onSelectProduct: Function,
  onRemoveProduct: Function,
  setPage: Function,
  showAll: Function,
  enabled: boolean,
  activeSelection: any,
  userRole: Number,
};

const CustomerProductList = ({
  products,
  pagination,
  showAll,
  isLoading,
  onOpenProduct,
  onSelectProduct,
  onRemoveProduct,
  setPage,
  enabled,
  activeSelection,
  userRole,
}: Props) => {
  let variants = [];

  const withOptions = _.flow(
    _.map(x => ({
      ...x,
      variantOptions: getVariantOptions(activeSelection, enabled, x.product, x.variant),
    })),
    _.filter(x => x.variantOptions.variantEnabled)
  )(products);

  if (!pagination.showAll) {
    variants = paginate(withOptions, pagination);
  } else {
    variants = withOptions;
  }
  return (
    <div className="CustomerProductList">
      <div className="product-list">
        {_.map(({variant, product, variantOptions}) => (
          <div
            key={variant.id}
            className="product">
            <CustomerProductCard
              product={product}
              variant={variant}
              onOpenProduct={onOpenProduct}
              onSelectProduct={onSelectProduct}
              onRemoveProduct={onRemoveProduct}
              enabled={enabled}
              variantOptions={variantOptions}
              activeSelection={activeSelection}
              userRole={userRole}/>
          </div>
        ), variants)}
        {!products.length && !isLoading &&
          <div className="empty-list-label">
            Inga produkter
          </div>
        }
      </div>
      {!pagination.showAll && amountOfPages(products, pagination) > 1 &&
        <div className="product-list-pagination">
          <Paginator
            pagination={pagination}
            pages={amountOfPages(products, pagination)}
            onSelect={setPage} />
          <div
            onClick={() => showAll()}
            className="show-all" >
            Visa alla
          </div>
        </div>
      }
    </div>
  );
};

export default CustomerProductList;



// WEBPACK FOOTER //
// ./src/components/CustomerProductList/CustomerProductList.js